// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"7dce958c","492":"7dce958c","798":"7dce958c","890":"7dce958c"}[chunkId] + ".chunk.css";
};